import React from 'react';
import styled, { keyframes } from 'styled-components';

// ✅ Animação de pulsação para o texto/overlay
const textPulseAnimation = keyframes`
  0% {
    transform: scale(1);
    opacity: 0.9;
  }
  50% {
    transform: scale(1.02);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.9;
  }
`;

const LockedItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.gray};
  margin-bottom: 5px;
`;

const LockedValueBox = styled.div`
  position: relative;
  padding: 8px 12px;
  min-height: 40px;
  background: repeating-linear-gradient(
    45deg,
    #f5f5f5,
    #f5f5f5 10px,
    #e0e0e0 10px,
    #e0e0e0 20px
  );
  border-radius: ${({ theme }) => theme.radii.sm};
  color: transparent;
  user-select: none;
  overflow: hidden;
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.fast};
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  }

  /* O overlay que cobre o conteúdo e que terá a animação */
  &::after {
    content: "🔒 Desbloquear com consulta completa";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(1.5px);
    color: ${({ theme }) => theme.colors.primaryDark};
    font-weight: 700;
    font-size: 14px;
    transition: ${({ theme }) => theme.transitions.fast};
    
    /* ✅ Aplica a animação de pulsação diretamente no texto */
    animation: ${textPulseAnimation} 1.5s infinite;
  }

  &:hover::after {
    /* Pausa a animação e muda o estilo no hover */
    animation: none;
    background: rgba(255, 255, 255, 0.95);
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const LockedValue = ({ label, onClick }) => (
  <LockedItemWrapper>
    <Label>{label}</Label>
    <LockedValueBox onClick={onClick}>
      **********
    </LockedValueBox>
  </LockedItemWrapper>
);

export default LockedValue;